import React from "react";
import TableAvatar from "./TableAvatar";
import Breadcrumbs from "../../../components/Breadcrumbs";

const AttendenceAdmin = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Attendance"
            title="Main"
            subtitle="Attendance"
            modalClass="col-auto float-end ms-auto"
          />
          {/* /Page Header */}

          <div className="row">
            <div className="col-lg-12">
              <TableAvatar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendenceAdmin;
